import { render, staticRenderFns } from "./CPWatchlist.vue?vue&type=template&id=1b9369e0&scoped=true&"
import script from "./CPWatchlist.vue?vue&type=script&lang=ts&"
export * from "./CPWatchlist.vue?vue&type=script&lang=ts&"
import style0 from "./CPWatchlist.vue?vue&type=style&index=0&id=1b9369e0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9369e0",
  null
  
)

export default component.exports